import { render, staticRenderFns } from "./simpleUploader.vue?vue&type=template&id=6a5128b9&"
import script from "./simpleUploader.vue?vue&type=script&lang=js&"
export * from "./simpleUploader.vue?vue&type=script&lang=js&"
import style0 from "./simpleUploader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a5128b9')) {
      api.createRecord('6a5128b9', component.options)
    } else {
      api.reload('6a5128b9', component.options)
    }
    module.hot.accept("./simpleUploader.vue?vue&type=template&id=6a5128b9&", function () {
      api.rerender('6a5128b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/example/simpleUploader/simpleUploader.vue"
export default component.exports